// extracted by mini-css-extract-plugin
module.exports = {"content":"Nav_content__3ujYB","item":"Nav_item__3VjZn","link":"Nav_link__2qtzG","developing":"Nav_developing__1adD9","select":"Nav_select__1L4OJ","head":"Nav_head__2lgT8"};